(function () {
    var flatPickerIncluded = document.querySelector('body').classList.contains('flatpicker');
    if (!flatPickerIncluded) {
        return;
    }

    flatpickr('.datepicker', {
        allowInput: true,
        enableTime: false,
        dateFormat: 'Y-m-d',
        locale: {
            firstDayOfWeek: 1,
            weekAbbreviation: 'v',
            weekdays: {
                shorthand: ['sön', 'mån', 'tis', 'ons', 'tor', 'fre', 'lör'],
                longhand: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag']
            },
            months: {
                shorthand: [
                    'jan',
                    'feb',
                    'mar',
                    'apr',
                    'maj',
                    'jun',
                    'jul',
                    'aug',
                    'sep',
                    'okt',
                    'nov',
                    'dec'
                ],
                longhand: [
                    'januari',
                    'februari',
                    'mars',
                    'april',
                    'maj',
                    'juni',
                    'juli',
                    'augusti',
                    'september',
                    'oktober',
                    'november',
                    'december'
                ]
            },
            rangeSeparator: ' till ',
            time_24hr: true,
            ordinal: () => {
                return '.';
            }
        }
    });
    //flatpickr(".timepicker", {
    //    allowInput: true,
    //    enableTime: true,
    //    noCalendar: true,
    //    dateFormat: "H:i",
    //    time_24hr: true,

    //});
})();
